export default "__VITE_ASSET__8d38bba9__"